export function isClientRole(user) {
  if (!user) {
    return false;
  }
  const roleId = Number(user.role_id);
  return roleId === 3 || roleId === 4;
}

export function isClientActivityVisible(user) {
  if (!user || !isClientRole(user)) {
    return false;
  }

  if (
    Number(user.role_id) === 4 &&
    (Number(user.team_role_id) === 1 || Number(user.team_role_id) === 3)
  ) {
    return String(user.plan_id) === "5" && String(user.subscription_free) === "0";
  }

  const roles = [1, 4, 3];
  const teamRoles = [1, 2, 3];
  if (!roles.includes(Number(user.role_id))) {
    return false;
  }
  if (
    user.team_role_id !== null &&
    user.team_role_id !== undefined &&
    Number(user.role_id) !== 4
  ) {
    return teamRoles.includes(Number(user.team_role_id));
  }
  return true;
}

export function isClientMenuEntryVisible(entry, user) {
  if (!user || !isClientRole(user)) {
    return false;
  }

  if (entry.type === "onboarding") {
    return Number(user.order_created) === 0;
  }

  if (entry.linkTo === "/activity") {
    return isClientActivityVisible(user);
  }

  const roles = entry.roles || [3, 4];
  if (!roles.includes(Number(user.role_id))) {
    return false;
  }

  if (
    entry.team_roles &&
    user.team_role_id !== null &&
    user.team_role_id !== undefined &&
    Number(user.role_id) !== 4
  ) {
    return entry.team_roles.includes(Number(user.team_role_id));
  }

  return true;
}

export function checkClientPlan(item, user, toastNotificationData) {
  if (!item) {
    return true;
  }
  if (toastNotificationData && toastNotificationData.dontChargePayments == 1) {
    return true;
  }
  if (
    user.subscription_status_id == 0 &&
    toastNotificationData &&
    toastNotificationData.trialPeriodData &&
    toastNotificationData.trialPeriodData.trial_period_ended == 0 &&
    item.trialPeriodAvailable != undefined &&
    item.trialPeriodAvailable == false
  ) {
    return false;
  }
  if (item.planIdAccess != undefined) {
    const planId = parseInt(user.plan_id, 10);
    const allowed = item.planIdAccess.map((id) => parseInt(id, 10));
    if (allowed.indexOf(planId) === -1) {
      return false;
    }
  }
  return true;
}

export const tabsMixin = {
  methods: {
    restrictedAccess: function () {
      this.$swal({
        type: "warning",
        html: this.$t("lang.label.restrictedaccess"),
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
      });
    },
    isClientMenuEntryVisible(entry) {
      const user = this.user || (this.$store && this.$store.state.authentication.user);
      return isClientMenuEntryVisible(entry, user);
    },
    checkClientPlan(item) {
      const user = this.user || (this.$store && this.$store.state.authentication.user);
      const toastNotificationData =
        this.toastNotificationData ||
        (this.$store && this.$store.state.authentication.toastNotificationData);
      return checkClientPlan(item, user, toastNotificationData);
    },
  },
};
